export default class Rule {
	constructor() {
		console.log( 'Rule!' );
	}
	addSubscriber ( email, mailingList, language = 'en', isUpdate = false ) {
		return fetch( `/wp-json/stok/v1/rule/subscriber/${email}`, {
			method: 'post',
			headers: {
				'Content-type': 'application/json; charset=UTF-8',
			},
			body: JSON.stringify( { mailingList: mailingList, language: language, isUpdate: isUpdate } ),
		} )
			.then( data => data.json() )
			.then( function ( data ) {
				console.log( 'Request succeeded with JSON response', data );
			} )
			.catch( function ( error ) {
				console.log( 'Request failed', error );
			} );
	}
}


// WEBPACK FOOTER //
// ./scripts/util/Rule.js